// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f990335","453":"d420ea71","667":"3b1a24a4","977":"03816716"}[chunkId] + ".chunk.js";
};